/* =========================================================================
   HOLY FOREST — HERO-KARUSSELL

   DIE FORTSCHRITTSLEISTE IST DIE UHR. Statt eines setInterval neben einer
   Anzeige laeuft eine einzige Animation; ihr Ende schaltet weiter. Anzeige
   und Ablauf koennen dadurch gar nicht auseinanderlaufen, und Anhalten ist
   ein pause() statt eines Aufraeumens von Zeitgebern.

   BILDER KOMMEN ERST, WENN SIE GEBRAUCHT WERDEN. Am 27.08.2026 gemessen:
   der Kopf holte beim Laden alle fuenf Kulissen und alle fuenf Flaschen,
   zusammen 619 KB — fuer eine sichtbare Folie. Zwei Gruende, beide nicht
   offensichtlich:
     · background-image wird auch bei visibility:hidden geholt. Verstecken
       spart keine Bytes.
     · loading="lazy" half nicht, weil alle Folien uebereinander in derselben
       Rasterzelle liegen — fuer den Browser sind sie alle im Sichtfeld.

   Folie 1 traegt ihre Bilder fest im Markup (sie ist das erste, was man
   sieht); ab Folie 2 stehen sie in data-Attributen. hole() setzt sie beim
   Anzeigen. Die FOLGENDE Folie wird vorgeladen, damit das Weiterschalten
   nicht auf einen Download wartet — aber erst im LEERLAUF, sonst nimmt das
   Vorladen dem ersten Bild die Bandbreite weg.

   ANHALTEN passiert bei: Zeigen darauf, Tastaturfokus darin, verstecktem
   Tab, und dauerhaft nach der ersten bewussten Bedienung.

   OHNE BEWEGUNGSWUNSCH (prefers-reduced-motion) laeuft nichts von selbst.
   ========================================================================= */

(function () {
  var spaeter = function (fn) {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: 2500 });
    else window.setTimeout(fn, 1200);
  };

  var starte = function (wurzel) {
    if (!wurzel || wurzel.dataset.hfBereit === '1') return;
    wurzel.dataset.hfBereit = '1';

    var folien = Array.prototype.slice.call(wurzel.querySelectorAll('.hf-kar__folie'));
    var punkte = Array.prototype.slice.call(wurzel.querySelectorAll('.hf-kar__punkt'));
    var steuer = wurzel.querySelector('.hf-kar__steuer');
    var balken = wurzel.querySelector('.hf-kar__balken span');
    var pause = wurzel.querySelector('.hf-kar__pause');
    if (folien.length < 1) return;

    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var takt = parseInt(wurzel.getAttribute('data-takt'), 10) || 0;
    var selbstlauf = takt > 0 && folien.length > 1 && !ruhig;

    if (steuer && folien.length > 1) steuer.hidden = false;
    if (!selbstlauf && pause) pause.hidden = true;

    var jetzt = 0;
    var lauf = null;
    var angehalten = false;
    var beendet = false;

    /* Holt die Bilder einer Folie — einmal, danach ist nichts mehr zu tun. */
    var hole = function (i) {
      var f = folien[(i + folien.length) % folien.length];
      if (!f || f.dataset.hfBild === '1') return;
      f.dataset.hfBild = '1';

      var flaeche = f.querySelector('.hf-kar__bild');
      if (flaeche && flaeche.dataset.kulisse) {
        flaeche.style.setProperty('--kar-kulisse', 'url(' + flaeche.dataset.kulisse + ')');
      }

      /* Flasche (alter Weg) oder fertiges Foto — je Folie gibt es nur eines.
         Erst die <source>-Elemente (Telefonfassung), dann das <img>: der
         Browser waehlt beim Setzen von src aus dem, was dann schon da ist. */
      f.querySelectorAll('source[data-srcset]').forEach(function (s) { s.srcset = s.dataset.srcset; });
      var img = f.querySelector('.hf-kar__flasche, .hf-kar__foto');
      if (img && img.dataset.src) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
      }
    };

    var uhrNeu = function () {
      if (lauf) { lauf.cancel(); lauf = null; }
      if (!selbstlauf || beendet || !balken || !balken.animate) return;
      lauf = balken.animate(
        [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
        { duration: takt, easing: 'linear', fill: 'forwards' }
      );
      lauf.onfinish = function () { zeige(jetzt + 1); };
      if (angehalten) lauf.pause();
    };

    var zeige = function (i) {
      jetzt = (i + folien.length) % folien.length;
      hole(jetzt);
      var naechste = jetzt + 1;
      spaeter(function () { hole(naechste); });
      folien.forEach(function (f, n) {
        var da = n === jetzt;
        f.classList.toggle('is-da', da);
        f.setAttribute('aria-hidden', da ? 'false' : 'true');
      });
      punkte.forEach(function (p, n) { p.setAttribute('aria-current', n === jetzt ? 'true' : 'false'); });
      uhrNeu();
    };

    /* Bewusste Bedienung beendet den Selbstlauf endgueltig. */
    var vonHand = function (i) {
      beendet = true;
      if (lauf) { lauf.cancel(); lauf = null; }
      if (pause) pause.hidden = true;
      zeige(i);
    };

    wurzel.querySelectorAll('.hf-kar__pfeil').forEach(function (b) {
      b.addEventListener('click', function () { vonHand(jetzt + (parseInt(b.getAttribute('data-richtung'), 10) || 1)); });
    });

    punkte.forEach(function (p, n) { p.addEventListener('click', function () { vonHand(n); }); });

    if (pause) {
      pause.addEventListener('click', function () {
        angehalten = !angehalten;
        if (lauf) { angehalten ? lauf.pause() : lauf.play(); }
        pause.setAttribute('aria-pressed', angehalten ? 'true' : 'false');
        pause.textContent = angehalten ? pause.getAttribute('data-an') : pause.getAttribute('data-aus');
      });
    }

    /* Schweben und Fokus halten an, ohne den Selbstlauf zu beenden. */
    var halt = function (an) {
      if (!lauf || angehalten) return;
      an ? lauf.pause() : lauf.play();
    };
    wurzel.addEventListener('pointerenter', function () { halt(true); });
    wurzel.addEventListener('pointerleave', function () { halt(false); });
    wurzel.addEventListener('focusin', function () { halt(true); });
    wurzel.addEventListener('focusout', function (e) { if (!wurzel.contains(e.relatedTarget)) halt(false); });
    document.addEventListener('visibilitychange', function () { halt(document.hidden); });

    wurzel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); vonHand(jetzt + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); vonHand(jetzt - 1); }
    });

    /* Wischen: nur waagerecht und nur ueber der Buehne, damit Blaettern
       auf dem Telefon nicht gestoert wird. */
    var startX = null, startY = null;
    var buehne = wurzel.querySelector('.hf-kar__buehne');
    if (buehne) {
      buehne.addEventListener('pointerdown', function (e) { startX = e.clientX; startY = e.clientY; });
      buehne.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) vonHand(jetzt + (dx < 0 ? 1 : -1));
      });
    }

    /* Kaufen aus dem Kopf heraus — derselbe Weg wie Tastes Kaufknopf. */
    wurzel.querySelectorAll('.hf-kar__kauf').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = Number(b.getAttribute('data-id'));
        if (!id) return;
        var folie = b.closest('.hf-kar__folie');
        var meldung = folie && folie.querySelector('.hf-kar__fehler');
        b.disabled = true;
        if (meldung) meldung.hidden = true;

        var korb = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var last = { items: [{ id: id, quantity: 1 }] };
        if (korb && korb.getSectionsToRender) {
          last.sections = korb.getSectionsToRender().map(function (s) { return s.id; });
          last.sections_url = window.location.pathname;
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(last)
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d.status) throw new Error(d.description || d.message);
            b.disabled = false;
            if (korb && korb.renderContents) korb.renderContents(d);
            else window.location.href = root + 'cart';
          })
          .catch(function (err) {
            b.disabled = false;
            if (meldung) { meldung.hidden = false; meldung.textContent = err.message || 'Das hat nicht geklappt. Bitte erneut versuchen.'; }
          });
      });
    });

    /* Folie 1 hat ihre Bilder fest im Markup; markieren, damit hole() sie
       nicht erneut anfasst. */
    if (folien[0]) folien[0].dataset.hfBild = '1';
    zeige(0);
  };

  var alle = function () { document.querySelectorAll('.hf-kar').forEach(starte); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();

  /* Der Theme-Editor rendert Sektionen neu. */
  document.addEventListener('shopify:section:load', alle);
})();
